export const ORDER_STATUS = {
  COMPLETED: "Order Completed",
};

export const PAYMENT_STATUS = {
  FULLY_PAID: "Fully Paid",
  PARTIALLY_PAID: "Partially Paid",
  NOT_PAID: "No Amount is Paid Yet",
};

export const PAYMENT_STATUS_COLORS = {
  FULLY_PAID: "#22c55e",
  PARTIALLY_PAID: "#f59e0b",
  NOT_PAID: "#ef4444",
};

export const COLLECTIONS = {
  ORDERS: "orders",
  PAYMENTS: "payments",
};

export const ADDRESS_TRUNCATE_LENGTH = 40;
export const ORDER_ID_TRUNCATE_LENGTH = 12;
